(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/index.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/index.js');
"use strict";


const Router = svs.ticket_partner.Router;
const target = document.getElementById('reactContainer');
target && ReactDOM.render(React.createElement(Router, null), target);

 })(window);